type Props = {
  title: string | JSX.Element;
};

export const CustomTabItemAtom = (props: Props) => {
  return (
    <div className="flex w-full items-center justify-center px-[15px] py-[12px]">
      <p className="text-[16px] leading-[26px]">{props.title}</p>
    </div>
  );
};
